import { getValuations } from '../../../HttpRequests/valuations'
import { loadValuations } from '../State/project'
import { setFetching } from '../State/fetching'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch) => {

  const { id } = getProps().match.params

  const params = {
    'filter[project_id]': id,
    include: 'project,activeInvoices',
  }

  dispatch(setFetching(true))

  try {

    const response = await getValuations({ id, params })

    dispatch(loadValuations(response.data.data))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(setFetching(false))

  }

}
